<template>
  <div class="custom-bg">
    <footer class="container-fluid mt-lg-5">
      <p class="text-center">
        © 2019 Copyright -
        <b-link v-bind:href="project.baseUrl" target="_blank" class="text-orange">CultureLabs</b-link>
      </p>
      <p>
        <b-link title="Not available yet" class="text-orange" v-b-tooltip.hover.bottom>Privacy Terms</b-link>
<!--        <b-link class="text-orange">Terms</b-link>-->
<!--        <b-link class="text-orange">Support</b-link>-->
      </p>
<!--      <small>* The front end has been developed by SingularLogic in the context of the CultureLabs project.</small>-->
    </footer>
  </div>
</template>

<script>
export default {
  props: {
    'project': Object
  }
}
</script>

<style>
.custom-bg {
  background-color: #f7f7f7
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue